/* eslint-disable max-lines-per-function */
import { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Tree } from 'primereact/tree'
import { useSelector } from 'react-redux'
import UpsertPopup from '../components/form/UpsertPopup'
import permissionProcessor from '../processor/permissionProcessor'
import { convertToPermission, updateToPermission } from '../utils/convertToTree'
import icons from '../constant/icons'
import userProcessor from '../processor/userProcessor'

function Permission() {
  const moduleName = 'chức năng'
  const [oneData, setOneData] = useState({})
  const [datas, setDatas] = useState([])
  const [visible, setVisible] = useState(false)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const listIcons = icons.map((item) => {
    return { id: item, name: <i className={item} /> }
  })
  const toggle = () => setVisible(!visible)

  const getDatas = async () => {
    const rs = await permissionProcessor.getAll()
    convertToPermission(rs)
    setDatas(rs)
  }
  const init = () => {
    getDatas()
  }
  useEffect(init, [])
  const save = async (data) => {
    const rs = await permissionProcessor.upsert(data)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) toggle()
    getDatas()
    userProcessor.getUserActions()
  }
  const deleteOnClick = async (id) => {
    const rs = await permissionProcessor.delete(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    getDatas()
    userProcessor.getUserActions()
  }

  const header = !oneData.id ? `Thêm mới ${moduleName}` : `Chỉnh sửa ${moduleName}`

  return (
    <>
      <UpsertPopup
        width="60%"
        visible={visible}
        toggle={toggle}
        header={header}
        data={oneData}
        onSave={save}
        selectSearcher={{ icon: 'id' }}
        fields={['name', 'link', 'code', 'icon']}
        maxLength={{ code: 30, name: 50, link: 30, icon: 30 }}
        name={{
          name: 'Tên',
          link: 'Đường dẫn',
          code: 'Mã',
          icon: 'Icon',
        }}
        options={{ icon: listIcons }}
        types={{ icon: 'select' }}
        disable={!oneData.id ? [] : ['code']}
      />
      <div className="card treetable-responsive">
        <Toolbar
          className="mb-4"
          right={
            <div className="flex">
              <Button
                icon="pi pi-plus"
                className="p-button-success mr-2"
                label="Thêm"
                onClick={() => {
                  setOneData({})
                  toggle()
                }}
              />
              <Button
                icon="pi pi-save"
                label="Lưu thứ tự chức năng"
                onClick={() => {
                  updateToPermission(datas)
                  permissionProcessor.updateMany(datas)
                  getDatas()
                  userProcessor.getUserActions()
                }}
              />
            </div>
          }
        />
        <Tree
          value={datas}
          dragdropScope="demo"
          onDragDrop={(event) => {
            setDatas(event.value)
          }}
          nodeTemplate={(item) => {
            return (
              <div className="flex justify-content-between align-items-center w-full">
                <p className="m-0">{item.name}</p>
                <div className="flex align-items-center">
                  <Button
                    icon="pi pi-plus"
                    className="p-button-rounded p-button-success mr-2"
                    onClick={() => {
                      setOneData({ parentId: item.id })
                      toggle()
                    }}
                    tooltip="Thêm phần tử con"
                    tooltipOptions={{ position: 'top' }}
                  />
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-warning mr-2"
                    onClick={() => {
                      setOneData(item)
                      toggle()
                    }}
                    tooltip="Sửa"
                    tooltipOptions={{ position: 'top' }}
                  />
                  <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger mr-2"
                    onClick={() => {
                      confirm({
                        action: () => deleteOnClick(item.id),
                        body: `Bạn có muốn xoá ${moduleName} này?`,
                      })
                    }}
                    tooltip="Xoá"
                    tooltipOptions={{ position: 'top' }}
                  />
                </div>
              </div>
            )
          }}
        />
      </div>
    </>
  )
}

export default withRouter(Permission)
